import contractState from '@/Mixins/contractState';

const jsdiff = require('diff');

export default {
  mixins: [contractState],

  methods: {
    references(value) {
      let html = value;
      // First loop through all the definitions
      // So we can add markup to show a popup

      // eslint-disable-next-line array-callback-return
      this.definitions.map((definition) => {
        // Loop through the references on the definition
        // eslint-disable-next-line array-callback-return
        let regexRef = definition.reference.replace(/\(/g, '\\(');
        regexRef = regexRef.replace(/\)/g, '\\)');

        const regex = new RegExp(`()(${regexRef})(?![A-Za-z0-9])(?![^<]*<\/span>)`, 'g');

        const extraClass = definition.type !== 'definition' ? 'clause' : '';
        const icon = definition.type !== 'definition' ? '' : '';
        // const icon = definition.type !== 'definition' ? '<i class="fa fa-external-link-alt"></i>' : '';

        html = html.replace(
          regex,
          `$1<span class="a trigger ${extraClass}" data-type="${definition.type}" data-reference="${definition.id}">${definition.reference}${icon}</span>`,
        );
      });

      // eslint-disable-next-line no-undef
      return html;
    },

    compareArray(newValue, originalValue) {
      if (!newValue && !originalValue) {
        return;
      }

      let modifiedOriginalValue = originalValue;
      if (!originalValue) {
        modifiedOriginalValue = '';
      }

      let comparison = '';

      const diff = jsdiff.diffArrays(modifiedOriginalValue, newValue);

      diff.forEach((part) => {
        let color = '';
        if (part.added) color = 'font-weight-bold';
        if (part.removed) color = 'removed';

        part.value.forEach((value) => {
          comparison = `${comparison}<li class="${color} d-flex">
            <span class="text-nowrap reference"></span>
            <div class="flex-grow-1"><p>${value}</p></div>
          </li>`;
        });
      });

      // eslint-disable-next-line consistent-return
      return comparison;
    },

    compareTable(newValue, originalValue) {
      if (!newValue && !originalValue) {
        return;
      }

      let modifiedOriginalValue = originalValue;
      if (!originalValue) {
        modifiedOriginalValue = '';
      }

      let comparison = '';

      const diff = jsdiff.diffArrays(modifiedOriginalValue, newValue);

      diff.forEach((part) => {
        let color = '';
        if (part.added) color = 'font-weight-bold';
        if (part.removed) color = 'removed';

        part.value.forEach((value) => {
          comparison = `${comparison}<tr class="${color}">${value}</tr>`;
        });
      });

      // eslint-disable-next-line consistent-return
      return comparison;
    },

    compareValue(newValue, originalValue) {
      if (!newValue && !originalValue) {
        return;
      }

      let modifiedOriginalValue = originalValue;
      if (!originalValue) {
        modifiedOriginalValue = '';
      }

      let comparison = '';

      const diff = jsdiff.diffWords(modifiedOriginalValue, newValue);

      diff.forEach((part) => {
        let color = '';
        if (part.added) color = 'font-weight-bold';
        if (part.removed) color = 'removed';

        comparison = `${comparison} <span class="${color}">${part.value}</span>`;
      });

      // eslint-disable-next-line consistent-return
      return comparison;
    },
  },

  computed: {
    classes() {
      if (this.block && this.block.class) {
        return this.block.class;
      }
      if (this.blockReference && this.blockReference.class) {
        return this.blockReference.class;
      }
      return '';
    },
  },
};
